export const Names = {
	story: {
		title: 'story',
		path: '/story'
	},
	filter: {
		title: 'filter',
		path: '/filter'
	},
	dashboard: {
		title: 'dashboard',
		path: '/dashboard'
	},
	profile: {
		title: 'profile',
		name: 'مشخصات کاربری',
		path: '/dashboard/profile'
	},
	content: {
		title: 'content',
		name: 'محتوای ارسالی',
		path: '/dashboard/content'
	},
	upload: {
		title: 'upload',
		name: 'ارسال محتوا',
		path: '/dashboard/upload'
	},
	login: {
		title: 'login',
		path: '/login'
	},
	notfound: {
		title: 'not found',
		path: '*'
	}
};
